import {ContextKey, Key} from '../storage';

export const modifiers: Record<ContextKey, (val: any) => any> = {
    [Key.Client]: (val: string) => val?.toLowerCase(),
};
